'use client';

import { colors as colors$1 } from '../Colors/index.js';
import { colors } from '../Utils/constants.js';

var themes = {
    primary: {
        borderFocus: colors.borderFocus,
        borderHover: colors.borderHover,
        borderNormal: colors.borderNormal,
        background: '#fff',
        text: colors$1.grey[20]
    },
    normal: {
        borderFocus: colors$1.neutral[95],
        borderHover: colors$1.neutral[95],
        borderNormal: colors$1.neutral[95],
        background: colors$1.neutral[95],
        text: colors$1.grey[50]
    }
};

export { themes as default };
//# sourceMappingURL=themes.js.map
